import { createSlice, current } from "@reduxjs/toolkit";
import { USER_LOGOUT } from "../SagaAction/actions";
import Swal from "sweetalert2";

export const ProductSlice = createSlice({
  name: "product",
  initialState: {
    checkedFilter:{
      Category:[],
      Designer:[],
      Color:[],
      Size:[],
      "Shipping Time": [],
    },
    wishlistLoder: false,
    filter: [],
    promoCode: null,
    wishlistItems: [],
    totalCount:0,
    cartItems: [],
    cartItemQty: 1,
    checkedItems: [],
    productsList: [],
    wishListAdd: [],
    viewProduct: [],
    productId: "",
    ViewReview: [],
    AddReview: [],
    loading: false,
    ProductlistLoading: false,
    ProductDetailLoading: false,
    reviewLoading: false,
    quantity: 1,
    SubTotal: null,
    TotalAmount: null,
    ProductDetailsData: [],
    inScListingData:[],
    OrderProducts: null,
    filterSelection: {
      category: [],
      designer: [],
      size: [],
      color: [],
      price: [],
      discount: [],
      ShippingTime: [],
    },
    isLoading : false
  },

  reducers: {
    inScListing: (state,action)=> {
      return{
        ...state,inScListingData:[...current(state.productsList),...action.payload]
      }
    },
    produtListDelete:(state,action)=> {
      return{
        ...state,productsList:[]
      }
    },
    // checkedFilterListing:(state, action)=> {
    //   // console.log(action?.payload,"HIREN")
    //     const fill={...state?.checkedFilter,[action?.payload?.name]:state?.checkedFilter?.[action?.payload?.name]?.some((e)=>e?.uniqid === action?.payload?.id?.uniqid) ? state?.checkedFilter?.[action?.payload?.name]?.filter((e)=>e?.uniqid !== action?.payload?.id?.uniqid ) : [...state?.checkedFilter?.[action?.payload?.name],action?.payload?.id]}
    //     // console.log(fill,"HIREN")
    //   return{...state,checkedFilter:fill }
    // },
    // deleteCheckFilterListing: (state,action)=> {  
    //   const finalData = {...state.checkedFilter,[action.payload.name] : state.checkedFilter?.[action.payload.name]?.some((e)=> e.uniqid === action?.payload?.id) ? state.checkedFilter?.[action.payload.name]?.filter((e)=> e.uniqid !== action?.payload?.id) : [...state.checkedFilter?.[action.payload.name],action?.payload?.id] }
    //   return{
    //     ...state,checkedFilter:finalData
    //   }
    // },
    addRemoveWishList: (state, action) => {
      const {_id, sizeId,isWishList} = action.payload
      let final = current(state.viewProduct);
      console.log(final,"FINALLYYY")
      const FinalData = final?.addVariant?.map((addVariant)=> {
        if(addVariant?._id === _id){
            return {
              ...addVariant,
              variantList: addVariant?.variantList?.map((variantList)=>{
                  if(variantList?.sizeId === sizeId){
                    return {
                      ...variantList,
                      isWishList
                    }
                  }else{
                    return variantList
                  }
              })
            }
        }else{
          return addVariant
        }
      })
      console.log(FinalData,"FinalData")
      return {
        ...state,
        viewProduct : {...state.viewProduct,addVariant : FinalData}
        // viewProduct:{...state.viewProduct,addVariant: current(state?.viewProduct?.addVariant).map((item) => {
        //   if (item._id === _id) {
        //     return { ...item, 
        //       variantList : item?.variantList?.map((vList)=> {
        //         console.log(vList,"vList")
        //         if(vList?.sizeId === sizeId){
        //           return {
        //             ...vList,
        //             isWishList:true
        //           }
        //         }else{
        //           return vList
        //         }
        //       })
        //     };  
        //   }
        //   return item;
        // })},
      };
    },
    setShopFilter(state, action) {
      return {
        ...state,
        filter: action.payload,
      };
    },
    removeShopFilter(state, action, filter, updatedFilter) {
      const remainingFilter = filter.filter(
        (item) => filter.item !== action.payload
        // filter.filter(a => a.id !== filter.id)
      );
      return {
        ...state,
        filter: filter.splice(filter, remainingFilter),
      };
    },
    savePromoCode(state, action) {
      return {
        ...state,
        promoCode: action.payload,
      };
    },
    addToWishlist(state, action) {
      return {
        ...state,
        wishlistItems: action.payload,
      };
    },
    incrementCartQuantity(state, action) {
      return {
        ...state,
        cartItemQty: action.payload,
      };
    },
    decrementCartQuantity(state, action) {
      return {
        ...state,
        cartItemQty: action.payload,
      };
    },
    checkItem(state, action) {
      return {
        ...state,
        checkedItems: action.payload,
      };
    },
    removeCheckItem(state, action, checkedItems, updatedFilter) {
      const remainingFilter = checkedItems?.filter(
        (item) => checkedItems?.item !== action.payload
      );
      return {
        ...state,
        checkedItems: checkedItems?.splice(checkedItems, remainingFilter),
      };
    },
    setProductIdRequest(state, action) {
      return {
        ...state,
        error: null,
        loading: true,
      };
    },
    setProductIdSuccess(state, action) {
      return {
        ...state,
        productId: action.payload,
        loading: false,
      };
    },
    setProductIdFailure(state, action) {
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    },
    setProductListRequest(state) {
      return { ...state, error: null, ProductlistLoading: true };
    },
    setProductListSuccess(state, action) {
      return {
        ...state,
        productsList: action.payload,
        ProductlistLoading: false,
      };
    },
    getTotalCount : (state,action) => {
      return {
        ...state,totalCount : action.payload
      }
    },
    setProductListFailure(state, action) {
      Swal.fire({
        position: "center",
        icon: "error",
        text: action?.payload?.message,
      });
      return {
        ...state,
        error: action.payload,
        ProductlistLoading: false,
      };
    },
    viewProductRequest(state) {
      return { ...state, error: null, isLoading: true };
    },
    viewProductSuccess(state, action) {
      return {
        ...state,
        viewProduct: action.payload,
        ProductDetailLoading: false,
        isLoading:false
      };
    },
    viewProductFailure(state, action) {
      return {
        ...state,
        error: action.payload,
        ProductDetailLoading: false,
        viewProduct: null,
        isLoading:false
      };
    },
    addProductReviewRequest(state) {
      return { ...state, reviewLoading: true };
    },
    addProductReviewSuccess(state, action) {
      return {
        ...state,
        AddReview: action.payload,
        reviewLoading: false,
      };
    },
    addProductReviewFailure(state) {
      return {
        ...state,
        reviewLoading: false,
      };
    },
    viewProductReviewRequest(state) {
      return { ...state, reviewLoading: true };
    },
    viewProductReviewSuccess(state, action) {
      return {
        ...state,
        ViewReview: action.payload,
        reviewLoading: false,
      };
    },
    viewProductReviewFailure(state) {
      return {
        ...state,
        reviewLoading: false,
      };
    },
    CartSummarySubtotalRequest(state) {
      return { ...state, loading: true };
    },
    CartSummarySubtotalSuccess(state, action) {
      return {
        ...state,
        SubTotal: action.payload,
        loading: false,
      };
    },
    CartSummarySubtotalFailure(state) {
      return {
        ...state,
        loading: false,
      };
    },
    CartSummaryTotalAmountRequest(state) {
      return { ...state, loading: true };
    },
    CartSummaryTotalAmountSuccess(state, action) {
      return {
        ...state,
        TotalAmount: action.payload,
        loading: false,
      };
    },
    CartSummaryTotalAmountFailure(state) {
      return {
        ...state,
        loading: false,
      };
    },
    addToCartRequest(state, action) {
      return { ...state, loading: true };
    },
    addToCartSuccess(state, action) {
      return {
        ...state,
        cartItems: action.payload,
      };
    },
    updatedCart(state, action) {
      // console.log(action?.payload, "HIREN");
      return {
        ...state,
        cartItems: action?.payload,
      };
    },
    addToCartFailure(state, action) {
      return {
        ...state,
        loading: false,
      };
    },
    DeleteFromCartItemRequest(state) {
      return { ...state, loading: true };
    },
    DeleteFromCartItemSuccess(state, action) {
      return {
        ...state,
        cartItems: action.payload,
        loading: false,
      };
    },
    DeleteFRomCartItemFailure(state) {
      return {
        ...state,
        loading: false,
      };
    },
    getProductDataRequest(state) {
      return { ...state, loading: true };
    },
    getProductDataSuccess(state, action) {
      return {
        ...state,
        ProductDetailsData: action.payload.payload,
        loading: false,
      };
    },
    getProductDataFailure(state) {
      return {
        ...state,
        loading: false,
      };
    },
    // new filter data
    getFilteredDataRequest(state, action) {
      return {
        ...state,
        loading: false,
      };
    },
    // working
    getFilteredDataSuccess(state, action) {
      let exact = current(state?.filterSelection);
      return {
        ...state,
        filterSelection: {
          ...exact,
          [action?.payload?.title]: [
            ...exact?.[action?.payload?.title],
            action?.payload?.select,
          ],
        },
      };
    },
    removeFilteredData(state, action) {
      let exact = current(state?.filterSelection);
      return {
        ...state,
        filterSelection: {
          ...exact,
          [action?.payload?.name]: [
            ...exact?.[action?.payload?.name].filter(
              (e) => e !== action.payload?.value
            ),
          ],
        },
      };
    },
    getPrice(state, action) {
      return {
        ...state,
        filterSelection: {
          ...state?.filterSelection,
          price: [
            "₹ " + action.payload[0] + " " + "-" + " ₹ " + action.payload[1],
          ],
        },
      };
    },
    removeAllfilter(state) {
      return {
        ...state,
        filterSelection: {
          category: [],
          designer: [],
          size: [],
          color: [],
          price: [],
          discount: [],
          shippingtime: [],
        },
      };
    },
    getFilteredDataFailure(state, action) {
      return {
        ...state,
        loading: false,
      };
    },

    getOderSummaryRequest(state, action) {
      return {
        ...state,
        loading: true,
      };
    },
    getOderSummarySuccess(state, action) {
      // console.log("action.payload of order",action?.payload);
      return {
        ...state,
        loading: false,
        OrderProducts: action?.payload,
      };
    },
    getOderSummaryFailure(state) {
      return {
        ...state,
        loading: false,
      };
    },
    // userWishlistAddRequest(state, action) {
    //   return {
    //     ...state,
    //     wishlistLoder: true,
    //   };
    // },
    // userWishlistAddSuccess(state,action) {
    //   Swal.fire({
    //     position: "center",
    //     icon: "success",
    //     text: action?.payload?.meta?.message,
    //   });
    //   console.log(action.payload,"PAYLOAD")
    //   return {
    //     ...state,
    //     wishlistLoder: false,
    //   };
    // },
    // userWishlistAddFailure(state,action) {
    //    Swal.fire({
    //     position: "center",
    //     icon: "error",
    //     text: action?.payload?.message,
    //   });
    //   return {
    //     ...state,
    //     wishlistLoder: false,
    //   };
    // },
    // userWishlistRemoveRequest : (state,action)=> {
    //   return{
    //     ...state,wishlistLoder:true
    //   }
    // },
    // userWishlistRemoveSuccess : (state,action)=>{
    //   Swal.fire({
    //     position: "center",
    //     icon: "success",
    //     text: action?.payload?.meta?.message,
    //   });
    //   return {
    //     ...state,
    //     wishlistLoder: false,
    //   };
    // },
    // userWishlistRemoveFailure : (state,action) => {
    //   Swal.fire({
    //     position: "center",
    //     icon: "error",
    //     text: action?.payload?.message,
    //   });
    //   return {
    //     ...state,
    //     wishlistLoder: false,
    //   };
    // }
  },
  extraReducers: (builder) => {
    builder.addCase(USER_LOGOUT, (state, action) => {
      localStorage.removeItem("authToken");
      localStorage.removeItem("email");
      localStorage.removeItem("isLogin");
      return {
        filter: [],
        promoCode: null,
        wishlistItems: [],
        cartItems: [],
        cartItemQty: 1,
        checkedItems: [],
        productsList: [],
        viewProduct: [],
        productId: "",
        ViewReview: [],
        AddReview: [],
        loading: false,
        SubTotal: null,
        TotalAmount: null,
        ProductDetailsData: [],
        filterSelection: {
          category: [],
          designer: [],
          size: [],
          price: [],
          color: [],
          discount: [],
          shippingtime: [],
        },
      };
    });
  },
});

export const {
  inScListing,
  checkedFilterListing,
  deleteCheckFilterListing,
  setShopFilter,
  removeShopFilter,
  savePromoCode,
  addToWishlist,
  addToCartRequest,
  addToCartSuccess,
  addToCartFailure,
  updatedCart,
  DeleteFromCartItemRequest,
  DeleteFromCartItemSuccess,
  DeleteFRomCartItemFailure,
  incrementCartQuantity,
  decrementCartQuantity,
  checkItem,
  getTotalCount,
  productListing,
  setProductListFailure,
  setProductListSuccess,
  setProductListRequest,
  viewProductRequest,
  viewProductSuccess,
  viewProductFailure,
  setProductIdRequest,
  setProductIdSuccess,
  setProductIdFailure,
  addProductReviewRequest,
  addProductReviewSuccess,
  addProductReviewFailure,
  viewProductReviewFailure,
  viewProductReviewSuccess,
  viewProductReviewRequest,
  CartSummarySubtotalRequest,
  CartSummarySubtotalSuccess,
  CartSummarySubtotalFailure,
  CartSummaryTotalAmountRequest,
  CartSummaryTotalAmountSuccess,
  CartSummaryTotalAmountFailure,
  getProductDataRequest,
  getProductDataSuccess,
  getProductDataFailure,
  getFilteredDataRequest,
  getFilteredDataSuccess,
  getFilteredDataFailure,
  removeAllfilter,
  getPrice,
  removeFilteredData,
  getOderSummaryRequest,
  getOderSummarySuccess,
  getOderSummaryFailure,
  addRemoveWishList,
  userWishlistAddRequest,
  userWishlistAddSuccess,
  userWishlistAddFailure,
  userWishlistRemoveRequest,
  userWishlistRemoveSuccess,
  userWishlistRemoveFailure,
  produtListDelete
} = ProductSlice.actions;
export default ProductSlice.reducer;
